const recaptchaStub = {
  execute(siteKey: string, action: ReCaptchaV2.Action) { return Promise.resolve('') },
  ready(callback: () => void) {}
} 

const reCAPTCHA_site_key = import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''

export function executeRecaptcha(action:string): Promise<string> {
  const grecaptcha = window.grecaptcha || (recaptchaStub)

  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(reCAPTCHA_site_key, {action}).then(function(token) {
        resolve(token)
      })
    })
  })
}


